import React from 'react';
import './button.scss';
import Icon from '../../mweb/Icon/Icon';
import ButtonLoader from './ButtonLoader';

const ButtonCounter = props => {
  const { className, onIncrement, onDecrement, disabled } = props;
  let { counter } = props;
  if (counter && counter < 10) counter = `0${counter}`;
  const noOp = () => {};
  if (disabled) return <ButtonLoader />;
  return (
    <div
      className={`${className} button-counter ${disabled ? 'disabled' : ''}`}
    >
      <Icon
        class="icon-common-minus decrement"
        size={10}
        onClick={disabled ? noOp : onDecrement}
      />
      <span className="counter">{counter}</span>
      <Icon
        class="icon-common-plus increment"
        size={10}
        onClick={disabled ? noOp : onIncrement}
      />
    </div>
  );
};

export default ButtonCounter;
